import React from 'react';
import { connectDeep } from 'redux-utils';
import styled from 'styled-components';

import { mapPageLayoutItems } from 'components/DiscoveryPage/utils';
import { AppType, RoutePaths } from '../../constants';
import { DiscoveryEntry } from '../../components/v2/Discovery/DiscoveryEntry';
import HomeContainer from '../../components/v2/HomeContainer';
import { getType, getPageType } from '../../utils.v2';
import { getFscViewType } from '../../utils';
import { Transition } from '../../components/v2/Transition';
import  { ScrollContainer } from '../../components/v2/ScrollContainer';

export const FULL_VH = document.documentElement.clientHeight;

const Container = styled.div`
  height: ${FULL_VH - 42}px;
  background: #FFFFFF;
`;

const mapStateToProps = (state: any) => {
  let { isApp, isNeutral, isTile, isClock } = getType(state.location);
  if (isNeutral) {
    // the location has changed, but the new page was not rendered, yet
    // the GalleryPage is still rendered so we must make sure we render the one that is already displayed
    isApp = getType(state.location.prev).isApp;
  }

  let pageLayoutType = getPageType({isApp, isClock, isTile})

  const {
    installed: {
      error: installedError,
    },
    fetchPageLayout: { loading: fetchPageLayoutLoading },
    pageLayoutItems: {
      [pageLayoutType]: pageLayoutItems = [],
    },
    galleryGrant: { userHasGrant, loading: loadingHasGalleryGrant }
  } = state.registry;

  const {
    direction,
    deeplinkStatus: { isOpen: deeplinkIsOpen }
  } = state.gallery;

  const loading =
    fetchPageLayoutLoading ||
    loadingHasGalleryGrant ||
    deeplinkIsOpen ||
    pageLayoutItems.length === 0;

  const error = installedError;

  return {
    loading,
    error,
    pageLayoutItems: mapPageLayoutItems(pageLayoutItems, state),
    direction,
    userHasGalleryGrant: userHasGrant,
    isApp,
    isClock,
    isTile
  };
};

type ReduxProps = ReturnType<typeof mapStateToProps>;

interface GalleryPageProps extends ReduxProps {

}

class GalleryPage extends React.Component<GalleryPageProps> {
  state = {
    scrollKey: ''
  };

   getScrollKey() {
    if (this.props.isApp) {
      this.setState({scrollKey: 'appsPage'});
    } else {
      if (this.props.isClock) {
        this.setState({scrollKey: 'clocksPage'});
      } else {
        this.setState({scrollKey: 'tilesPage'});
      }
    }
  }

  private renderBody() {
    const { pageLayoutItems, userHasGalleryGrant, isApp, isTile, isClock } = this.props;

    const viewName = getPageType({ isApp, isClock, isTile })
    return (
      <ScrollContainer
          navbarHeight={42}
          scrollKey={this.state.scrollKey}
      >
        <Container>
          <DiscoveryEntry
            fscViewName={`${getFscViewType(viewName)} Gallery`}
            pageLayoutItems={pageLayoutItems}
            userHasGalleryGrant={userHasGalleryGrant}
            isClock={isClock}
            appType={isTile ? AppType.TILE : AppType.APP}
          />
        </Container>
      </ScrollContainer>
    )
  }

  componentWillMount() {
    this.getScrollKey();
  }

  render() {
    const { loading, error, isApp, isClock, isTile } = this.props;

    let homeRoute;
    if (isClock) {
      homeRoute = RoutePaths.GALLERY_CLOCKS;
    }
    if (isApp) {
      homeRoute = RoutePaths.GALLERY_APPS;
    }

    if (isTile) {
      homeRoute = RoutePaths.GALLERY_TILES;
    }

    return (
      <HomeContainer selected={homeRoute}>
        {
          loading || error ?
            <Transition loading={loading} error={error} headerHeight={42} /> :
            this.renderBody()
        }
      </HomeContainer>
    );
  }

}

export default connectDeep(mapStateToProps)(GalleryPage);
